import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { ActivityProvider } from './state/ActivityContext'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ActivityProvider>
      <App />
    </ActivityProvider>
  </StrictMode>,
)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // The application remains usable online if service-worker registration fails.
    })
  })
}
